import axios, { AxiosResponse } from "axios";

let baseUrl = process.env.REACT_APP_API_URL;

export function createProjectAPI(projectData:any) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/projects/create`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: projectData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function updateProject(projectData:any) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/projects/update`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: projectData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function createDraftAPI(draftData:any) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/draftprojects/create`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: draftData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function getDraftsAPI() {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/draftprojects`,
            method: "GET",
            headers: {
                Accept: "application/json"
            },
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function getProjectsAPI() {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/projects`,
            method: "GET",
            headers: {
                Accept: "application/json"
            },
          })
            .then((response) => {
                console.log('--response---',response)
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function removeProjectAPI(projectData:any) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/projects/remove`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: projectData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function removeDraftProjectAPI(projectData:any) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/draftprojects/remove`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: projectData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}